export const LOGIN = { path: '/login', name: 'TSP Login' };
/* ECN
export const ORDER = { path: '/order', name: 'TSP Orders' };
export const TRADE = { path: '/trade', name: 'TSP Trades' };
export const TRADE_SUMMARY = { path: '/summary', name: 'TSP Summary' };
export const TRADE_SUMMARY_CHART = { path: '/summary/chart', name: 'TSP Summary' };
export const DASHBOARD = { path: '/dashboard', name: 'TSP Summary' };
*/

// AD GROUPS

export const ECN_ORDER_AD_GROUP = 'TSP Orders';
export const ECN_TRADE_AD_GROUP = 'TSP Trades';
export const ECN_SUMMARY_AD_GROUP = 'TSP Summary';

export const IDQS_ORDER_AD_GROUP = 'TSP IDQS Orders';
export const IDQS_TRADE_AD_GROUP = 'TSP IDQS Trades';

export const NMS_ORDER_AD_GROUP = 'TSP NMS Orders';
export const NMS_TRADE_AD_GROUP = 'TSP NMS Trades';

export const DASHBOARD_AD_GROUP = 'TSP Dashboard';

export const ORDER_BOOK_AD_GROUP = 'TSP Orderbook';
export const ORDER_BOOK_ADMIN_AD_GROUP = 'TSP Orderbook Admin';

export const ECN_AD_GROUPS = [ECN_ORDER_AD_GROUP, ECN_TRADE_AD_GROUP, ECN_SUMMARY_AD_GROUP];
export const IDQS_AD_GROUPS = [IDQS_ORDER_AD_GROUP, IDQS_TRADE_AD_GROUP];
export const NMS_AD_GROUPS = [NMS_ORDER_AD_GROUP, NMS_TRADE_AD_GROUP];

// HEADER MENU

// ECN

export const ORDER = {
  link: 'Order',
  key: 'ecnOrder',
  parentKey: 'ECN',
  name: ECN_ORDER_AD_GROUP,
  path: '/order'
};
export const OPEN_ORDER = {
  link: 'Open Order',
  key: 'ecnOpenOrder',
  parentKey: 'ECN',
  name: ECN_ORDER_AD_GROUP,
  path: '/open-order'
};
export const HELP = {
  link: 'Help',
  key: 'ecnOpenHelp',
  parentKey: 'ECN',
  name: ECN_ORDER_AD_GROUP,
  path: '/help'
};
export const TRADE =
  {
    link: 'Trade',
    key: 'ecnTrade',
    parentKey: 'ECN',
    name: ECN_TRADE_AD_GROUP,
    path: '/trade'
  };

export const TRADE_SUMMARY = {
  link: 'Summary',
  key: 'ecnTradeSummary',
  parentKey: 'ECN',
  name: ECN_SUMMARY_AD_GROUP,
  path: '/summary'
};

export const TRADE_SUMMARY_CHART = {
  link: 'Summary Chart',
  key: 'ecnTradeSummaryChart',
  parentKey: 'ECN',
  name: ECN_SUMMARY_AD_GROUP,
  path: '/summary/chart'
};

export const ORDER_BOOK = {
  link: 'Order Book',
  key: 'sysOrderBook',
  parentKey: 'sysOrderBook',
  name: ORDER_BOOK_AD_GROUP,
  path: '/sys-order-book'
};

export const DASHBOARD = {
  link: 'Dashboard',
  key: 'dashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/dashboard'
};

export const ATS_TDDS_DASHBOARD = {
  link: 'Dashboard',
  key: 'atsTddsDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/ats-tdds-dashboard'
};

export const OVERNIGHT_DASHBOARD = {
  link: 'Dashboard',
  key: 'overnightDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/overnight-dashboard'
};

export const HISTORIC_DASHBOARD = {
  link: 'Dashboard',
  key: 'historyDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/history-dashboard'
};

export const ATS_TDDS_HISTORIC_DASHBOARD = {
  link: 'Dashboard',
  key: 'atsTddsHistDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/history-ats-tdds-dashboard'
};

export const HISTORIC_OVERNIGHT_DASHBOARD = {
  link: 'Dashboard',
  key: 'historicovernightDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/history-overnight-dashboard'
};

export const RISK_DASHBOARD = {
  link: 'Dashboard',
  key: 'riskDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/risk-dashboard'
};

export const HISTORY_RISK_DASHBOARD = {
  link: 'Dashboard',
  key: 'historyRiskDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/history-risk-dashboard'
};

export const MOBILE_DASHBOARD = {
  link: 'Dashboard',
  key: 'mobileDashboard',
  parentKey: 'dashboard',
  name: DASHBOARD_AD_GROUP,
  path: '/mobile-dashboard'
};

// IDQS

export const IDQS_ORDER = {
  link: 'Order',
  key: 'idqsOrder',
  parentKey: 'IDQS',
  name: IDQS_ORDER_AD_GROUP,
  path: '/idqs/order'
};

export const IDQS_OPEN_ORDER = {
  link: 'Open Order',
  key: 'idqsOpenOrder',
  parentKey: 'IDQS',
  name: IDQS_ORDER_AD_GROUP,
  path: '/idqs/open-order'
};
export const IDQS_TRADE =
{
  link: 'Trade',
  key: 'idqsTrade',
  parentKey: 'IDQS',
  name: IDQS_TRADE_AD_GROUP,
  path: '/idqs/trade'
};

// NMS

export const NMS_ORDER = {
  link: 'Order',
  key: 'nmssOrder',
  parentKey: 'NMS',
  name: NMS_ORDER_AD_GROUP,
  path: '/nms/order'
};

export const NMS_OPEN_ORDER = {
  link: 'Open Order',
  key: 'nmsOpenOrder',
  parentKey: 'NMS',
  name: NMS_ORDER_AD_GROUP,
  path: '/nms/open-order'
};
export const NMS_TRADE =
{
  link: 'Trade',
  key: 'nmsTrade',
  parentKey: 'NMS',
  name: NMS_TRADE_AD_GROUP,
  path: '/nms/trade'
};

export const headerLinks = [
  {
    link: 'ECN',
    accessKey: 'ecn',
    sublinks: [ORDER, OPEN_ORDER, TRADE, TRADE_SUMMARY, HELP]
  },
  {
    link: 'IDQS',
    accessKey: 'idqs',
    sublinks: [ IDQS_ORDER, IDQS_OPEN_ORDER, IDQS_TRADE ]
  },
  {
    link: 'NMS',
    accessKey: 'nms',
    sublinks: [ NMS_ORDER, NMS_OPEN_ORDER, NMS_TRADE ]
  }
];
